export default "__VITE_ASSET__0e433ae7__"